import { atom } from 'jotai';
import { mqttClientAtom } from '../connection/mqttConnectionAtom';
import { setDebugLabels } from '../utils/atomUtils';
import { handleLastSubscriberUnsubscribe } from '../utils/mqttClientOperations';
import {
  isLastSubscriber,
  isValidSubscriber,
  logSubscriberRemoval,
} from '../utils/subscriberUtils';
import {
  removeSubscriberAtom,
  subscriberSetAtomFamily,
} from './subscriptionAtoms';

export const unsubscribeFromTopicAtom = atom(
  null,
  async (
    get,
    set,
    {
      topic,
      subscriberId,
    }: {
      topic: string;
      subscriberId: string;
    },
  ) => {
    const client = get(mqttClientAtom);
    const currentSubscribers = get(subscriberSetAtomFamily(topic));

    if (!isValidSubscriber(currentSubscribers, subscriberId)) {
      return;
    }

    const shouldUnsubscribeFromTopic = isLastSubscriber(currentSubscribers);
    set(removeSubscriberAtom, { topic, subscriberId });

    if (shouldUnsubscribeFromTopic) {
      await handleLastSubscriberUnsubscribe(client, topic);
    } else {
      logSubscriberRemoval(topic, subscriberId, currentSubscribers.size - 1);
    }
  },
);

setDebugLabels({
  unsubscribeFromTopicAtom,
});
